import React from 'react';
import ValuationTableWidgetBuilder from './ValuationTableWidgetBuilder';
import ValuationTableWidgetRenderer from './ValuationTableWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { ValuationTableWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faScaleBalanced } from '@fortawesome/free-solid-svg-icons';

export { default as ValuationTableWidgetRenderer } from './ValuationTableWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'valuation_table',
  meta: {
    label: 'Valuation Multiples',
    icon: React.createElement(FontAwesomeIcon, { icon: faScaleBalanced }),
    description: 'TTM valuation, profitability, leverage, and liquidity ratios from market data',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'VALUATION_TABLE',
  },
  defaultSize: { w: 5, h: 5, minW: 3, minH: 4 },
  defaultConfig: () => ({} as ValuationTableWidgetConfig),
  Builder: ValuationTableWidgetBuilder,
  Renderer: ValuationTableWidgetRenderer,
  Preview,
};
